/**
 * Dehydrating 101 guide pages: progressive enhancement only.
 * Without JS the page still reads top to bottom, tables show every row and
 * the "On this page" links still jump to their sections.
 *
 *  1. Highlights the current section in the sticky "On this page" bar.
 *  2. Wires up category filter chips on tables flagged with [data-dg-filterable].
 */
(function () {
  'use strict';

  // Several sections include this script; only the first copy does the work.
  if (window.__dgGuide) return;
  window.__dgGuide = true;

  var tocObserver = null;

  /* ---------- 1. Scroll-spy for the on-page nav ---------- */
  function initToc() {
    if (tocObserver) { tocObserver.disconnect(); tocObserver = null; }

    var nav = document.querySelector('[data-dg-toc]');
    if (!nav || !('IntersectionObserver' in window)) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));

    // Link targets are the theme's .anchor helpers, which sit above their section
    // (offset by the sticky header + this bar). Watch the section itself instead.
    var idFor = new Map();
    var targets = [];
    links.forEach(function (link) {
      var anchor = document.getElementById(link.getAttribute('href').slice(1));
      if (!anchor) return;
      var section = anchor.classList.contains('anchor') ? anchor.parentElement : anchor;
      idFor.set(section, anchor.id);
      targets.push(section);
    });
    if (!targets.length) return;

    function setActive(id) {
      links.forEach(function (link) {
        var on = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
          // Keep the active chip visible in the horizontally scrolling bar.
          var left = link.offsetLeft - nav.clientWidth / 2 + link.clientWidth / 2;
          nav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    tocObserver = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (entry) { return entry.isIntersecting; })
        .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
      if (visible.length) setActive(idFor.get(visible[0].target));
    }, { rootMargin: '-160px 0px -65% 0px', threshold: 0 });

    targets.forEach(function (target) { tocObserver.observe(target); });
    setActive(idFor.get(targets[0]));
  }

  /* ---------- 2. Table filter chips ---------- */
  function initFilters() {
    document.querySelectorAll('[data-dg-filterable]').forEach(function (root) {
      var bar = root.querySelector('[data-dg-filters]');
      var rows = root.querySelectorAll('tbody tr[data-dg-category]');
      if (!bar || !rows.length || bar.dataset.dgReady) return;
      bar.dataset.dgReady = 'true';

      bar.hidden = false; // chips are only useful when JS can drive them

      bar.addEventListener('click', function (event) {
        var button = event.target.closest('button[data-dg-value]');
        if (!button) return;

        var value = button.getAttribute('data-dg-value');
        bar.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === button));
        });
        rows.forEach(function (row) {
          row.hidden = value !== '*' && row.getAttribute('data-dg-category') !== value;
        });
      });
    });
  }

  function init() {
    initToc();
    initFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run inside the theme editor when a section is added or reloaded.
  document.addEventListener('shopify:section:load', init);
})();